import React, { useEffect, useState } from "react";
import {
  Button,
  Fade,
  IconButton,
  Stack,
  TextField
} from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { IconTrash, IconX } from "@tabler/icons-react";
import Modal from "@mui/material/Modal";
import { grey } from "@mui/material/colors";
import { toast } from "react-toastify";
import { v4 as uuid } from "uuid";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: "sm",
  width: "90%",
  maxHeight: "80vh",
  bgcolor: 'background.paper',
  borderRadius: 2,
  border: '0px solid #000',
  boxShadow: 24,
  px: 4,
  py: 3,
  overflowY: "auto"
};

const CreateTagModal = ({ open, handleClose, tag, handleSubmit, onRemove, project }) => {
  const [name, setName] = useState("");
  const [title, setTitle] = useState("");
  const [id, setId] = useState("");

  useEffect(() => {
    if (tag) {
      setName(tag?.name || "");
      setTitle(tag?.title || "");
      setId(tag?.id || "");
    } else {
      // Generate new ID for new tags
      setId(uuid());
    }
  }, [tag, open]);

  const onCreate = async () => {
    if (!name.trim()) {
      toast.error("Tag name is required!");
      return;
    }

    const newTag = {
      id: id,
      name: name.trim(),
      title: title.trim()
    };

    handleSubmit(newTag);
    onClose();
  };

  const onClose = () => {
    setName("");
    setTitle("");
    setId("");
    handleClose();
  };

  const handleDelete = () => {
    if (onRemove && tag?.id) {
      onRemove(tag.id);
      onClose();
    }
  };

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Fade in={open} timeout={500}>
        <Box>
          <Box sx={{ position: "fixed", top: 10, right: 10 }}>
            <IconButton
              size={"small"}
              onClick={onClose}
              color={"#FFF"}
            >
              <IconX color={grey[300]} />
            </IconButton>
          </Box>

          <Stack direction={"column"} gap={2} sx={style}>
            <Typography variant={"h4"} fontWeight={"bold"} sx={{ mb: 1 }}>
              {tag ? "Edit Tag" : "Create New Tag"}
            </Typography>

            <TextField
              label={"Tag Name"}
              value={name}
              onChange={e => setName(e.target.value)}
              helperText="The display name of the tag"
              required
            />

            <TextField
              label={"Tag Title"}
              value={title}
              onChange={e => setTitle(e.target.value)}
              helperText="Optional title or description for the tag"
            />

            <Stack direction={'row'} gap={1} useFlexGap flexWrap={"wrap"}>
              <Button
                variant={"contained"}
                color={"secondary"}
                sx={{ borderRadius: 1, textTransform: "capitalize" }}
                disabled={!name.trim()}
                onClick={onCreate}
              >
                Save
              </Button>
              <Button
                variant={"outlined"}
                color={"secondary"}
                sx={{ borderRadius: 1, textTransform: "capitalize" }}
                onClick={onClose}
              >
                Cancel
              </Button>
              {
                tag?.id &&
                <Button
                  variant={"outlined"}
                  color={"error"}
                  sx={{ borderRadius: 1, textTransform: "capitalize", ml: "auto" }}
                  onClick={handleDelete}
                >
                  <IconTrash size={20} />
                </Button>
              }
            </Stack>
          </Stack>
        </Box>
      </Fade>
    </Modal>
  );
};

export default CreateTagModal;
